import request from '@teetsh/app/src/utils/request';

export default function getEntity({
  token,
  entityType,
  entityId,
}: {
  token: string;
  entityType: string;
  entityId: string;
}) {
  const requestURL = `/shares/${token}`;
  return request(requestURL, {
    method: 'GET',
    params: { entityType, entityId },
  });
}
